/** Semantic feedback colors (errors, alerts) — not tied to brand primary. */
export const feedbackPalette = {
  error: {
    background: '#FEE8E8',
    border: '#FAD2D2',
    title: '#C5221F',
    text: '#B31412',
  },
} as const;
